import { useSelector } from 'react-redux'
import { useState, useEffect, Fragment } from 'react'
import { InstituteHealthService } from '@apis'
import Empty from '@commons/empty'
import Row from '@components/row'
import Button from '@components/button'
import { StyleGrid } from './style'
import HealthServiceCard from '@commons/cards/healthService'
import HealthServiceCardLoader from '@commons/cards/healthService/loader'
import { useNavigate } from 'react-router-dom'
const Services = () => {
  const navigate = useNavigate()
  const {
    items: healthServices,
    loading,
    totalPages,
  } = useSelector((state: any) => state.instituteHealthServices)
  const { data: user } = useSelector((state: any) => state.user)
  const [params, setParams] = useState({
    page: 1,
    limit: 6,
    userId: user?.id,
  })

  const handleClick = async (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-id]')
    if (!!cross) {
      const id = cross.getAttribute('data-cross-id')
      const healthService = healthServices?.find((item: any) => item?.id == id)
      if (!!healthService?.id) {
        const slug = `${healthService?.name.toLowerCase().replaceAll(' ', '-')}-${id}`
        navigate(`/institution/health-services/${slug}`, {
          state: healthService,
        })
      }
    }
  }

  const fetchData = async (params, action = 'set') => {
    await InstituteHealthService.list({
      params,
      action,
    }).catch(() => {})
  }

  const onLoadMore = async () => {
    const updateParams = {
      ...params,
      page: params?.page + 1,
    }
    setParams(updateParams)
    await fetchData(updateParams, 'append')
  }

  useEffect(() => {
    if (!healthServices?.length) {
      fetchData(params)
    }
  }, [])

  return (
    <>
      {!!loading ? (
        <StyleGrid>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return (
                <Fragment key={index}>
                  <HealthServiceCardLoader />
                </Fragment>
              )
            })}
        </StyleGrid>
      ) : (
        <>
          {!!healthServices?.length ? (
            <StyleGrid onClick={handleClick}>
              {healthServices?.map((healthService: any) => {
                return (
                  <Fragment key={healthService?.id}>
                    <HealthServiceCard healthService={healthService} />
                  </Fragment>
                )
              })}
            </StyleGrid>
          ) : (
            <Empty />
          )}
        </>
      )}
      {params?.page < totalPages && (
        <Row justifyContent="center">
          <Button title="Load More" onClick={onLoadMore} />
        </Row>
      )}
    </>
  )
}

export default Services
